import { Link, ListItem } from '@chakra-ui/react';
import NextLink from 'next/link';

export default function BlogMenuItem({ name, path, active }) {
  const activeMenuItemStyles = active;
  return (
    <div>
      <ListItem m="0 45px 30px 0">
        <NextLink href={path || '#'} passHref  prefetch={false}>
          <Link
            color="white"
            fontSize="16px"
            lineHeight="20px"
            pos="relative"
            whiteSpace="nowrap"
            _hover={{ textDecoration: 'none' }}
            {...(activeMenuItemStyles
              ? {
                  fontWeight: 'bold',
                  _before: {
                    content: "''",
                    position: 'absolute',
                    bottom: '-12px',
                    w: '100%',
                    h: '5px',
                    backgroundColor: 'white',
                  },
                }
              : '')}
          >
            {name}
          </Link>
        </NextLink>
      </ListItem>
    </div>
  );
}
